import * as React from 'react';
/**
 *
 * Original name: encrypted
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=47498%3A4132
 *
 */
export const EncryptedLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M10 11c0-1.346.654-2 2-2s2 .654 2 2c0 1.066-.41 1.698-1.25 1.915V15h-1.5v-2.085C10.41 12.698 10 12.066 10 11Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m5 7.278 7-3.36 7 3.36V11c0 6.186-6.447 8.837-6.722 8.947l-.278.111-.278-.111C11.447 19.837 5 17.187 5 11V7.278Zm7 11.15c1.155-.553 5.5-2.928 5.5-7.428V8.222L12 5.582l-5.5 2.64V11c0 4.5 4.344 6.875 5.5 7.427Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
